import { createClient } from "@supabase/supabase-js";

// Only the project URL and the publishable key ever reach the browser. RLS protects all data.
export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: "chatsleek-auth",
    },
  },
);
